/* eslint-disable prefer-destructuring */

import { getCustomChartDef } from './CustomDef';
import { getWebTestChartDef } from './GetWebTestChartDef';
import { voipChartDef } from './VoipChartDef';
import { getWifiConnectTestChartDef } from './WifiConectTestChartDef';

export const getPerfChartDef = (test) => {
    if (!test) {
        return {};
    }

    const testType = test.testType || test.typeNode;

    if (testType.name === 'Web') return getWebTestChartDef(test);
    if (testType.name === 'wifiConnect') return getWifiConnectTestChartDef(test);
    if (testType.group === 'VoIP') return voipChartDef;
    return getCustomChartDef(testType);
};
